import { useCallback } from 'react';

import { create } from 'zustand';

import { createUnreadSlice } from './actions';
import { UnreadStore } from './types';
import { useGetUnreadInboxEntries } from '../../../services/inboxEntries.service';

export const useUnreadStore = create<UnreadStore>()((set, get, store) => ({
  ...createUnreadSlice(set, get, store),
}));

export function useRefreshUnreads() {
  const { getUnreadInboxEntries } = useGetUnreadInboxEntries();
  const { setUnreads } = useUnreadStore();

  const refreshUnreads = useCallback(async () => {
    const data = await getUnreadInboxEntries();
    setUnreads(data);
  }, [getUnreadInboxEntries, setUnreads]);

  return { refreshUnreads };
}
